import { format, max } from 'date-fns';

type GetFormattedLatestDateParams = {
  dateOne: string;
  dateTwo: string;
};

export const getFormattedLatestDate = ({ dateOne, dateTwo }: GetFormattedLatestDateParams) => {
  return format(max([dateOne, dateTwo]), 'yyyy-MM-dd');
};
